class VisibilityValidator {
    /**
     * @param {Konva.Shape} target
     * @returns {boolean}
     */
    validate(target) {
        return target.isVisible();
    }
}

export { VisibilityValidator };
//# sourceMappingURL=VisibilityValidator.js.map
